// Ant Design 5 needs this patch on React 19 (official compatibility package).
import "@ant-design/v5-patch-for-react-19";
import "@refinedev/antd/dist/reset.css";
import "dayjs/locale/tr";
import relativeTime from "dayjs/plugin/relativeTime";

import dayjs from "dayjs";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { initErrorTracking } from "./error-tracking";

initErrorTracking();
dayjs.extend(relativeTime);
dayjs.locale("tr");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
